export const phoneRegex = /^\+380 \(\d{2}\) \d{3}-\d{2}-\d{2}$/;

export const dateOfBirthRegex = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/;
